import React, { useState, useEffect } from 'react'
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import MissionForm from './MissionForm' // ✨ BARU: Mengimpor form misi

export default function MissionsDaily() {
  const [list, setList] = useState([])
  const [showForm, setShowForm] = useState(false) // ✨ BARU: State untuk menampilkan form

  useEffect(() => {
    load()
  }, [])

  const load = async () => {
    const snap = await getDocs(collection(db, 'missions_daily'))
    setList(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  }

  // ✨ HAPUS KESELURUHAN FUNGSI createMission DI ATAS
  // Karena kita akan menggunakan MissionForm sepenuhnya

  const remove = async (id) => {
    const confirmDelete = window.confirm('Yakin ingin menghapus misi ini?\n\nSistem akan otomatis menyapu bersih misi ini dari HP Mitra (selama belum diselesaikan/diklaim).');
    
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, 'missions_daily', id));
        alert('Misi berhasil dihapus!');
        load(); // Refresh daftar misi
      } catch (error) {
        console.error("Gagal menghapus misi:", error);
        alert('Gagal menghapus misi.');
      }
    }
  }

  return (
    <div>
      {/* ✨ BARU: Jika showForm true tampilkan form, jika false tampilkan tombol */}
      {showForm ? (
        <MissionForm 
          scope="daily" 
          onClose={() => {
            setShowForm(false) // Tutup form
            load() // Muat ulang data terbaru
          }} 
        />
      ) : (
        <button
          onClick={() => setShowForm(true)}
          className="mb-4 px-4 py-2 bg-green-600 hover:bg-green-500 rounded text-white"
        >
          + Tambah Misi Harian
        </button>
      )}

      <div className="space-y-3">
        {list.map((m) => (
          <div
            key={m.id}
            className="p-4 bg-gray-800/50 border border-gray-700 rounded-lg flex justify-between items-start gap-4 hover:bg-gray-800 transition shadow-sm"
          >
            <div className="flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-white">{m.title}</span>
                {/* Badge Divisi */}
                <span className={`text-[10px] px-2 py-0.5 rounded-full border ${m.role === 'therapist' ? 'border-orange-500 text-orange-400' : 'border-blue-500 text-blue-400'}`}>
                  {m.role?.toUpperCase()}
                </span>
                {/* Badge Layanan */}
                <span className="text-[10px] bg-gray-700 px-2 py-0.5 rounded text-gray-300 uppercase">
                  {m.serviceType === 'all' ? 'Semua Layanan' : m.serviceType}
                </span>
              </div>
              
              <div className="text-xs text-gray-400 mt-1 line-clamp-1 italic">{m.description}</div>
              
              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-[11px]">
                <div className="text-green-400 font-medium">💰 Bonus: Rp {m.bonus?.toLocaleString('id-ID')}</div>
                <div className="text-blue-400">🎯 Target: {m.target} Order</div>
                <div className="text-purple-400">
                  👥 Target: {
                    m.targetAudience === 'all' ? 'Semua Mitra' : 
                    m.targetAudience === 'level' ? `Level ${m.targetLevel}` : 
                    `Spesifik (${m.targetUids?.length || 0} Mitra)`
                  }
                </div>
              </div>
            </div>
            <button
              onClick={() => remove(m.id)}
              className="px-3 py-1.5 bg-red-900/40 hover:bg-red-600 text-red-400 hover:text-white rounded transition text-xs font-bold border border-red-800/50 hover:border-red-600"
            >
              Hapus
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
